<template>
    <div class="content error">
        <PageError :page="page" :msg="msg"></PageError>
    </div>
</template>
<script>
    import PageError from "@/components/PageError.vue";

    export default {
        name: "ErrorView",
        components: {
            PageError,
        },
        props: {
            page: String,
            msg: String,
        },
        watch: {
            // msg değiştiğinde (örneğin hata geldiğinde)
            msg: {
                handler(newVal, oldVal) {
                    console.groupCollapsed("%c[ErrorView Watch Triggered]", "color: red; font-weight: bold;");
                    console.log("🧩 Page:", this.page);
                    console.log("🔴 New msg:", newVal);
                    console.log("🟡 Old msg:", oldVal);
                    console.trace("📍 Stack trace");
                    console.groupEnd();
                },
                immediate: true, // bileşen mount olur olmaz da çalışsın
            },
        },
        mounted() {
            console.info("✅ ErrorView mounted:", {
                page: this.page,
                msg: this.msg,
            });
        },
    };
</script>
